import { createContext, useContext } from 'react';

export const EmailContext = createContext<{
  openCompose: (options?: { to?: string }) => void;
  closeCompose: () => void;
} | null>(null);

export const useEmailContext = () => {
  const context = useContext(EmailContext);
  if (!context) {
    return {
      openCompose: () => console.warn('EmailContext not available'),
      closeCompose: () => {},
    };
  }
  return context;
};
